import api from "@/lib/api";

/**
 * Upload a media file (image / video) via multipart POST to /api/admin/upload.
 * Returns the absolute or relative URL (e.g. "/api/media/foo.mp4") that the
 * backend assigned to the file.
 */
export async function uploadMedia(file, customName = "") {
  const fd = new FormData();
  fd.append("file", file);
  if (customName) fd.append("custom_name", customName);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { url, filename, size, content_type }
}
